import Vue from 'vue'
import Router from 'vue-router'

import VueGoodTable from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTable)

// Pay.SignLedger
const AttRepDetails = () => import('@/views/attendance/ReportCheckinDetails')
const AttRepSummary = () => import('@/views/attendance/ReportCheckinSummary')
const AttRepDaily = () => import('@/views/attendance/ReportDailySummary')

const UserPayData = () => import('@/views/pay/UserPayData')
const PayReports = () => import('@/views/pay/SalaryHeader')
const PayReportDetails = () => import('@/views/pay/SalaryDetails')
const PayReportsPast = () => import('@/views/pay/SalaryHeaderPast')
const PayReportDetailsPast = () => import('@/views/pay/SalaryDetailsPast')
const Gratuity = () => import('@/views/pay/Gratuity')

const Home = () => import('@/views/pay/Home')
const Users = () => import('@/views/admin/Users')
const Holidays = () => import('@/views/admin/Holidays')
const Departments = () => import('@/views/admin/Departments')
const Locations = () => import('@/views/admin/Locations')
const Devices = () => import('@/views/admin/Devices')
const Contact = () => import('@/views/admin/Contact')
const UserManual = () => import('@/views/admin/UserManual')

const Signin = () => import('@/views/auth/Signin')
const Signup = () => import('@/views/auth/Signup')
const ForgotPassword = () => import('@/views/auth/ForgotPassword')

// Containers
const TheContainer = () => import('@/containers/TheContainer')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/home',
      name: '',
      component: TheContainer,
      children: [


        {
          path: '/attendance/details',
          name: 'Report - Details',
          component: AttRepDetails
        },
        {
          path: '/attendance/summary',
          name: 'Report - Summary',
          component: AttRepSummary
        },
        {
          path: '/attendance/daily',
          name: 'Report - Daily',
          component: AttRepDaily
        },

        {
          path: '/pay/userPayData',
          name: 'User - Pay Data',
          component: UserPayData
        },
        {
          path: '/pay/salaryHeader',
          name: 'Pay Reports',
          component: PayReports
        },
        {
          path: '/pay/salaryDetails',
          name: 'Pay Report Details',
          component: PayReportDetails,
          props: true,
        },
        {
          path: '/pay/salaryHeaderPast',
          name: 'Past Pay Reports',
          component: PayReportsPast
        },
        {
          path: '/pay/salaryDetailsPast',
          name: 'Past Pay Report Details',
          component: PayReportDetailsPast,
          props: true,
        },
        {
          path: '/pay/gratuity',
          name: 'Gratuity',
          component: Gratuity,
          props: true,
        },

        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: '/admin/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/admin/holidays',
          name: 'Holidays',
          component: Holidays
        },
        {
          path: '/admin/departments',
          name: 'Departments',
          component: Departments
        },
        {
          path: '/admin/locations',
          name: 'Locations',
          component: Locations
        },
        {
          path: '/admin/devices',
          name: 'Devices',
          component: Devices
        },
        {
          path: '/admin/contact',
          name: 'Contact SignLedger',
          component: Contact
        },
        {
          path: '/admin/usermanual',
          name: 'Admin User Manual',
          component: UserManual
        },

        {
          path: '/auth/signin',
          name: 'Signin',
          component: Signin
        },
        {
          path: '/auth/signup',
          name: 'Signup',
          component: Signup
        },
        {
          path: '/auth/forgotPassword',
          name: 'Forgot Password',
          component: ForgotPassword
        },

      ]
    }
  ]
}

